// extracted by mini-css-extract-plugin
module.exports = {"page":"Pokemon_page__3hfvR","content":"Pokemon_content__2kUUT","pokemon":"Pokemon_pokemon__2Hemg","descr":"Pokemon_descr__3WvUU","button":"Pokemon_button__MrCIE"};